export default __webpack_public_path__ + "static/media/dmente_black_background.781edee1.png";